module.exports = __webpack_public_path__ + "media/functional__tony_1.189109f5.webm";